var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightDoubleStrokeRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7929 5.2929C12.1834 4.90237 12.8166 4.90237 13.2071 5.29289L19.2071 11.2928C19.5976 11.6834 19.5976 12.3165 19.2071 12.7071L13.2072 18.7071C12.8166 19.0976 12.1835 19.0976 11.7929 18.7071C11.4024 18.3166 11.4024 17.6834 11.7929 17.2929L17.0858 12L11.7929 6.70711C11.4024 6.31659 11.4024 5.68342 11.7929 5.2929Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.79289 5.2929C5.18341 4.90237 5.81658 4.90237 6.2071 5.29289L12.2071 11.2928C12.5976 11.6834 12.5976 12.3165 12.2071 12.7071L6.20716 18.7071C5.81664 19.0976 5.18347 19.0976 4.79295 18.7071C4.40242 18.3166 4.40241 17.6834 4.79293 17.2929L10.0858 12L4.7929 6.70711C4.40237 6.31659 4.40237 5.68342 4.79289 5.2929Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightDoubleStrokeRounded);
export default __webpack_public_path__ + "static/media/arrow-right-double-stroke-rounded.7d736fe0925d004d3e3c476f5978c856.svg";
export { ForwardRef as ReactComponent };